import { useTranslation } from 'react-i18next';
import { type ConfiguratorModuleSpecsFragment } from '../../../../api/fragments/ConfiguratorModuleSpecs';
import ApplicationModuleFinanceProductAssignments from '../shared/ApplicationModuleFinanceProductAssignments';

export type UpdateFinanceProductAssignmentsValue = {
    dealerFinanceProducts: Record<string, string[]>;
};

export type FinanceProductAssignmentsProps = {
    module: ConfiguratorModuleSpecsFragment;
};

const FinanceProductAssignments = ({ module }: FinanceProductAssignmentsProps) => {
    const { t } = useTranslation(['eventApplicationModuleDetails']);

    return (
        <ApplicationModuleFinanceProductAssignments
            module={module}
            noItemText={t('eventApplicationModuleDetails:tabs.financeProducts.noData')}
        />
    );
};

export default FinanceProductAssignments;
